/**
 * This store used to set help/script data into vuex store
 */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  helpTextData: null,
};

const getters = {
};

const mutations = {
  /**
   * set help script data into vuex store through mutation
   * @param {*} state vuex state
   * @param {*} helpText help script to be stored in vuex
   */
  setHelpTextMutate(state, helpText) {
    state.helpTextData = helpText;
  },
};

const actions = {
  /**
   * call mutation setHelpTextMutate to store help script in vuex store
   * @param {*} blurbs help script from page API response
   */
  setHelpTextAction({ commit }, blurbs) {
    for (let i = 0; i < blurbs.length; i += 1) {
      if (blurbs[i].location === 'helptext' && blurbs[i].visible === true) {
        commit('setHelpTextMutate', blurbs[i].content);
      }
    }
  },
};
/**
 * export module to main store.js
 */

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/helptext.js